// src/ui/PageHeader.jsx
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PageTitle, SmallText } from "./Typography.jsx";
import BackToDashboard from "./BackToDashboard";

export default function PageHeader({ title, subtitle, actions, showBack, backTarget }) {
  const location = useLocation();

  const autoShowBack = useMemo(() => {
    if (showBack !== undefined) return showBack;
    const path = location?.pathname || "";
    return path.startsWith("/ceramics/") && !path.startsWith("/ceramics/dashboard");
  }, [location.pathname, showBack]);

  return (
    <div
      className="flex flex-col gap-4 pb-4 border-b 
                 bg-[var(--mudo-bg-soft)]/40 backdrop-blur-md rounded-xl
                 px-4 pt-4 shadow-sm"
      style={{ borderColor: "var(--mudo-border)" }}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          {autoShowBack ? <BackToDashboard target={backTarget} /> : null}

          <div className="min-w-0">
            <PageTitle className="truncate">{title}</PageTitle>
            {subtitle && (
              <SmallText className="opacity-70 truncate">{subtitle}</SmallText>
            )}
          </div>
        </div>

        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
